import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { updateTask } from '../../Redux/GetSlice';
import DatePicker from 'react-datepicker';
import { useTaskData } from '../../hooks/useTaskData';
import axios from 'axios';
import { useSelector } from 'react-redux';

export default function TaskStatusNextStep({
    currentTaskId,
    // note,
    handleChange,
    setSelectedStatusNextStepDate,
    selectedReminderDate,
    isReminder,
    selectedStatusNextStepDate,
    setSelectedReminderDate,
    taskItem,
    getTaskMail,
    nextStepNote
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [updateDeadline, setUpdateDeadline] = useState(false);
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const { note } = useSelector((state) => state?.redux)
    const {
        // State values
        selectedReminderDate: reduxSelectedReminderDate,
        selectedStatusNextStepDate: reduxSelectedStatusNextStepDate,
        notes: reduxNote,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,

        // Action functions
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate: updateSelectedReminderDateRedux,
        updateSelectedStatusNextStepDate: updateSelectedStatusNextStepDateRedux,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,

        // Utility functions
        handleDateSelect: handleDateSelectFromHook,
        handleUpdateTask: handleUpdateTaskFromHook,
    } = useTaskData();


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                handleUpdateNotes()
                setIsOpen(false);

            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [taskItem, note]);

    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }
        return dateOption;
    };

    const handleReminderSelection = (dateOption) => {
        const dateObj = new Date(getFormattedDate(dateOption));
        const formattedDate = dateObj.toISOString();
        updateSelectedStatusNextStepDateRedux(formattedDate);
        updateSelectedReminderDateRedux(formattedDate);

        if (setSelectedStatusNextStepDate) {
            setSelectedStatusNextStepDate(formattedDate);
        }
        if (setSelectedReminderDate) {
            setSelectedReminderDate(formattedDate);
        }

        setIsOpen(false);
        handleUpdateTaskFromHook(formattedDate, 'statusNextStep', taskItem);

    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';
        return date.toLocaleString('en-US', {
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };

    const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
    const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
    const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
    const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };

    const handleDateChange = (date) => {
        setCustomDate(date);
        setShowDatePicker(false);
        handleReminderSelection(date);
    };



    const currentNote = reduxNote !== undefined ? reduxNote : note;


    const currentHandleChange = (e) => {
        const newValue = e.target.value;
        updateNote(newValue);

        // if (handleChange) {
        //     handleChange(e);
        // }
    };



    const handleUpdateNotes = async () => {
        try {
            const data = {
                notes: note
            }
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${currentTaskId}`,
                data
            );



        } catch (error) {

            console.error('TaskStatusNextStep - Error updating task:', error);
            throw error;
        }
    }

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            <a
                href="#"
                className="text-listdrop !text-[13px]"
                style={{ textDecoration: 'none', display: 'inline-block' }}
                onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(!isOpen);
                }}
            >
                Next Step...
                {currentNote && (
                    <div className="mt-1 text-gray-500 break-words whitespace-pre-wrap max-w-xs">
                        {currentNote}
                    </div>
                )}
            </a>

            {isOpen && (
                <div className="absolute mt-2 w-[260px] bg-white shadow-lg rounded-md p-3 z-10">
                    <div className="flex justify-between items-center mb-3" style={{ padding: '8px' }}>
                        <span
                            className="font-medium text-sm text-gray-800"
                            style={{
                                textDecoration: 'none',
                                fontSize: '11px',
                                fontWeight: 700,
                                fontFamily: 'inherit',
                            }}
                        >
                            Status and Next Step...
                        </span>
                        <button
                            className="text-blue-500 text-sm"
                            onClick={() => setIsOpen(false)}
                            style={{
                                fontSize: '11px',
                                fontWeight: '700',
                                fontFamily: 'inherit',
                            }}
                        >
                            Clear
                        </button>
                    </div>
                    <div>
                        <textarea
                            placeholder="Add an optional note or next step"
                            className="w-full border border-gray-200 rounded p-2 text-sm resize-none mb-2"
                            rows={2}
                            value={currentNote}
                            onChange={currentHandleChange}
                            style={{ backgroundColor: 'white' }}
                        ></textarea>
                    </div>
                    <div>
                        <ul className="text-xs text-gray-800 divide-y divide-gray-100 px-0 mb-0">
                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(today)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-sun-fill text-gray-900"></i>
                                    <span className="text-xs">Later today</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(today))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(tomorrow)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-moon-stars-fill text-gray-500"></i>
                                    <span className="text-xs">Tomorrow</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(tomorrow))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(inTwoDays)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-clock-fill text-gray-500"></i>
                                    <span className="text-xs">In two days</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(inTwoDays))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(nextWeek)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-week-fill text-gray-500"></i>
                                    <span className="text-xs">Next week</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(nextWeek))}
                                </span>
                            </li>

                            <li
                                className="flex items-center px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => setShowDatePicker(!showDatePicker)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-event-fill text-gray-500"></i>
                                    <span className="text-xs">Pick a date</span>
                                </span>
                            </li>

                            {showDatePicker && (
                                <li>
                                    <div className="absolute left-1/2 top-0 -translate-x-1/2 mt-2 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 p-2">
                                        <DatePicker
                                            selected={customDate}
                                            onChange={handleDateChange}
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                            placeholderText="Select date and time"
                                            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                                            calendarClassName="!border-0 !shadow-none"
                                            inline
                                            minDate={new Date()}
                                        />
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="mt-3 p-2">
                        <label className="flex items-center text-sm gap-2">
                            <input
                                type="checkbox"
                                checked={updateDeadline}
                                onChange={() => setUpdateDeadline(!updateDeadline)}
                                style={{ backgroundColor: 'white' }}
                            />
                            Also update the deadline date
                        </label>
                    </div>
                </div>
            )}
        </div>
    );
}
